import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function useEndGame(animalName, actionName, otherAnimalName, actions) {

    const { 
        gameStatus,
        player,
        currentPosition,
        otherAnimalCurrentPosition,
        setGameStatus,
        setPlayer,
        setPositions,
    } = useAppStore( useShallow((state) => ({
        gameStatus: state.gameStatus,
        player: state.player,
        currentPosition: state.positions[animalName]?.current,
        otherAnimalCurrentPosition: state.positions[otherAnimalName].current,
        setGameStatus: state.setGameStatus,
        setPlayer: state.setPlayer,
        setPositions: state.setPositions,
    })));

    const distance = new Array(3);
    let xOrZ, xOrZValue, collision;
    const AREA_LIMIT = 15;
    const outOfArea = Math.abs(currentPosition.x) > AREA_LIMIT ||
        Math.abs(currentPosition.z) > AREA_LIMIT;

    useFrame((state, delta) => {
        distance[0] = otherAnimalCurrentPosition.x - currentPosition.x;
        distance[2] = otherAnimalCurrentPosition.z - currentPosition.z;
        xOrZ = Math.abs(distance[0]) >= Math.abs(distance[2]) ? 0 : 2;
        xOrZValue = distance[xOrZ];
        collision = Math.abs(xOrZValue) < 0.8;

        if ( gameStatus === 'start' && ( collision || outOfArea ) ) {
            if (outOfArea) {
                setPositions(animalName, new THREE.Vector3(currentPosition.x, -20, currentPosition.z));
            }
            setPlayer(false)
            setGameStatus('ending')
        }

        if (gameStatus === 'ending') {
            if (animalName === 'rabbit') {
                actions['run'].stop();
                if (collision) {
                    actions['die'].clampWhenFinished = true;
                    actions['die'].
                        setLoop(THREE.LoopOnce).
                        play();
                }
                if (!actions['die'].isRunning()) {
                    setGameStatus('end')
                }
            } else {
                actions['walk'].stop();
            }
        }
    });
};



